import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { isJobModuleRunningNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

export const useJobModuleActionRunning = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState } = useUpdateJobModuleStateQueryData();
  const { setUpdatedState } = useAsyncActions();

  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleRunningNotificationPayload(payload)) return;

    notify.info({
      key: payload.id,
      title: t("broadcast:jobModuleRunning", {
        moduleName: payload.job_module.module_name,
      }),
      duration: ONE_MINUTE_IN_SECONDS,
    });

    setUpdatedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Running");
  };

  return { runAction };
};
